import { Button, Typography } from "@mui/material";
import * as React from "react";
import * as Service from "../../Services/service";

export default function CustomButton({ id, Icon, title, Input, onClick, EndIcon, hide }) {
  const windowSize = Service.getSizeWindows();
  return (
    <Button variant="contained" component="label" id={id} onClick={onClick}
      sx={hide ? { display: "none" } : {
        textAlign: "center", borderRadius: "17px", fontWeight: 500, fontSize: "11px", backgroundColor: "#c59812", color: "white !important",
        ":hover": { backgroundColor: "#c99b13", fontWeight: 700 }
      }}
      startIcon={<>{Icon}</>}
      endIcon={<>{EndIcon}</>}
    >
      <Typography sx={{ typography: { sm: 'h6', xs: 'body2' }, color: "white" }}>
        {title}{Input}
      </Typography>
    </Button>
  );
}
